'use client';

import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { motion } from 'motion/react';

export function RotateScreenPrompt() {
  return (
    <div className='fixed inset-0 z-[200] flex flex-col items-center justify-center gap-8 bg-background p-6'>
      <motion.div
        className='h-32 w-32 rounded-2xl bg-muted/50 p-4'
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        <DotLottieReact
          src='/rotate-animation.lottie'
          loop
          autoplay
          className='h-full w-full'
        />
      </motion.div>
      <div className='max-w-sm space-y-2 text-center'>
        <motion.p
          className='text-lg font-semibold'
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          Rotate your screen
        </motion.p>
        <motion.p
          className='text-sm text-muted-foreground'
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          For the best experience, please rotate your device to landscape mode to continue.
        </motion.p>
      </div>
    </div>
  );
}
